import type { HttpErrorResponse } from '@angular/common/http';

import type { RatingScale } from '@core/candidate-evaluation-settings-types';
import { createSingleEntityStore, pipeState } from '@core/ngrx-legacy';

const { actions, reducer, namespace, selectors } = createSingleEntityStore<RatingScale>()(
  'candidate-evaluation-default-rating-scale',
  {
    customActions: adapter => ({
      update: (state, payload: RatingScale) => adapter.markAsPending(state),
      updateSuccess: (state, payload: RatingScale) =>
        pipeState(
          state,
          next => adapter.save(next, payload),
          next => adapter.markAsLoaded(next),
        ),
      updateFailed: (state, payload: { error: HttpErrorResponse }) =>
        pipeState(
          state,
          next => adapter.setError(next, payload),
          next => adapter.markAsLoaded(next),
        ),
    }),
  },
);

const DefaultRatingScaleActions: Pick<
  typeof actions,
  'fetch' | 'fetchSuccess' | 'fetchFailed' | 'update' | 'updateSuccess' | 'updateFailed'
> = actions;

const DefaultRatingScaleSelectors = selectors;

export {
  DefaultRatingScaleActions,
  DefaultRatingScaleSelectors,
  reducer as DefaultRatingScaleReducer,
  namespace as DefaultRatingScaleNamespace,
};
